// extracted by mini-css-extract-plugin
export default {"main":"Main_main__x7GJT","main__section":"Main_main__section__-hYwl","main__section_type_wide":"Main_main__section_type_wide__M3rm1"};